import 'twin.macro';
import 'styled-components/macro';

import { AccountActions } from './account/AccountActions';
import { MainMenu } from './MainMenu';

export const LoggedOutMenu = ({ shouldHideAccountActions }: { shouldHideAccountActions?: boolean }) => (
  <>
    {!shouldHideAccountActions && <AccountActions tw="mb-3" />}
    <MainMenu title="Navigate" tw="sm:hidden" shouldHideContent shouldHideInspirationLibrary />
  </>
);
